import { Grid } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton';

export default function LoadMoreSpinner({number}) {

    return (
        <Grid container spacing={2}>
            {[...Array(number)].map((_, index) =>(
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Skeleton variant="rect" height="50px" width="100%" />
                    </Grid>
            ))}
        </Grid>
    )
}
